import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    participantsLabel: 'Players',
    participantsOne: 'player',
    participantsFew: 'players',
    participantsMany: 'players',
    prizesLabel: 'Prizes',
    prizesOne: 'item',
    prizesFew: 'items',
    prizesMany: 'items',
    join: 'Join',
    login: 'Log in to join',
    joined: "You're in",
    ended: 'The giveaway is over',
  },
  ru: {
    participantsLabel: 'Участники',
    participantsOne: 'участник',
    participantsFew: 'участника',
    participantsMany: 'участников',
    prizesLabel: 'Разыграем',
    prizesOne: 'предмет',
    prizesFew: 'предмета',
    prizesMany: 'предметов',
    join: 'Участвовать',
    login: 'Войди, чтобы участвовать',
    joined: 'Ты в игре',
    ended: 'Раздача закончилась',
  },
  uz: {
    participantsLabel: 'Ishtirokchilar',
    participantsOne: 'ishtirokchi',
    participantsFew: 'ishtirokchi',
    participantsMany: 'ishtirokchi',
    prizesLabel: 'Sovrinlar',
    prizesOne: 'ta buyum',
    prizesFew: 'ta buyum',
    prizesMany: 'ta buyum',
    join: 'Ishtirok etish',
    login: 'Kirib, ishtirok et',
    joined: 'Sen oʻyindasan',
    ended: 'Ulashish tugadi',
  },
  fa: {
    participantsLabel: 'شرکت‌کننده‌ها',
    participantsOne: 'شرکت‌کننده',
    participantsFew: 'شرکت‌کننده',
    participantsMany: 'شرکت‌کننده',
    prizesLabel: 'جایزه‌ها',
    prizesOne: 'آیتم',
    prizesFew: 'آیتم',
    prizesMany: 'آیتم',
    join: 'شرکت کن',
    login: 'برای شرکت وارد شو',
    joined: 'تو داخل بازی هستی',
    ended: 'پخش تمام شد',
  },
  pt: {
    participantsLabel: 'Participantes',
    participantsOne: 'participante',
    participantsFew: 'participantes',
    participantsMany: 'participantes',
    prizesLabel: 'Prêmios',
    prizesOne: 'item',
    prizesFew: 'itens',
    prizesMany: 'itens',
    join: 'Participar',
    login: 'Entre para participar',
    joined: 'Você está dentro',
    ended: 'O sorteio acabou',
  },
  tr: {
    participantsLabel: 'Katılımcılar',
    participantsOne: 'katılımcı',
    participantsFew: 'katılımcı',
    participantsMany: 'katılımcı',
    prizesLabel: 'Ödüller',
    prizesOne: 'eşya',
    prizesFew: 'eşya',
    prizesMany: 'eşya',
    join: 'Katıl',
    login: 'Katılmak için giriş yap',
    joined: 'Katıldın',
    ended: 'Çekiliş bitti',
  },
});
